<template>
  <aside
    class="fixed top-0 left-0 z-40 h-screen pb-10 bg-tertiaire shadow-primaire shadow-lg transition-transform duration-300 overflow-y-auto"
    :style="{
      width: isSidebarOpen ? sidebarWidth : '0',
      transform: isSidebarOpen ? 'translateX(0)' : 'translateX(-100%)',
      overflow: isSidebarOpen ? 'visible' : 'hidden',
    }" aria-label="Sidebar">
    <div class="flex flex-col flex-1 h-full px-3 overflow-y-auto">
      <button
        @click="closeSidebar"
        class="absolute top-2 right-4 w-12 h-12 flex items-center justify-center rounded-full hover:bg-action" 
        aria-label="Fermer la barre latérale" title="Fermer la barre latérale">
        <font-awesome-icon icon="times" class="text-primaire hover:text-tertiaire text-2xl" />
      </button>
      <div class="flex items-center justify-center w-full mx-auto h-auto mb-5">
        <router-link to="/"
          @click="handleLinkClick">
          <img src="/src/assets/images/logo.svg"
            class="min-w-48 min-h-48 pt-2 sm:pt-4 md:w-60 md:h-60 bg-tertiaire inline-flex items-center justify-center rounded-sm"
            alt="Animaux de la seconde chance"
            title="Animaux de la seconde chance" />
        </router-link>
      </div>
      <ul class="space-y-2 font-medium">
        <li class="mt-0">
          <router-link to="/" @click="handleLinkClick"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group"
            active-class="bg-primaire text-secondaire">
            <font-awesome-icon icon="home"
              class="w-5 h-5 text-tertiaire transition duration-75 group-hover:secondaire dark:text-tertiaire dark:group-hover:text-tertiaire" />
            <span class="ml-3">Accueil</span>
          </router-link>
        </li>
        <!-- New dropdown menu -->
        <li>
          <div @click="toggleDropdown('apropos')"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group cursor-pointer">
            <font-awesome-icon icon="paw"
              class="w-5 h-5 text-tertiaire transition duration-75 group-hover:secondaire" />
            <span class="ml-3">À propos</span>
            <font-awesome-icon :icon="dropdownStates.apropos ? 'chevron-up' : 'chevron-down'"
              class="ml-auto text-tertiaire" />
          </div>
          <ul v-if="dropdownStates.apropos" class="pl-6 mt-2 space-y-2">
            <li>
              <router-link to="notre-mission" @click="handleLinkClick"
                class="flex items-center p-2 text-navigation bg-gray-100 border-2 border-navigation rounded-lg hover:bg-primaire hover:text-tertiaire ho group"
                active-class="text-[#2fa960] border-[#2fa960] bg-cyan-50">
                <span class="ml-3">Notre mission</span>
              </router-link>
            </li>
            <li>
              <router-link to="faire-un-don" @click="handleLinkClick"
                class="flex items-center p-2 text-navigation bg-gray-100 border-2 border-navigation rounded-lg hover:bg-primaire hover:text-tertiaire ho group"
                active-class="text-[#2fa960] border-[#2fa960] bg-cyan-50">
                <span class="ml-3">Faire un don</span>
              </router-link>
            </li>
            <li>
              <router-link to="adoption" @click="handleLinkClick"
                class="flex items-center p-2 text-navigation bg-gray-100 border-2 border-navigation rounded-lg hover:bg-primaire hover:text-tertiaire ho group"
                active-class="text-[#2fa960] border-[#2fa960] bg-cyan-50">
                <span class="ml-3">Info Adoptions</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="famille-accueil" @click="handleLinkClick"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group"
            active-class="bg-primaire text-secondaire">
            <font-awesome-icon :icon="['fab', 'bluesky']"
              class="w-5 h-5 text-tertiaire transition duration-75 group-hover:secondaire dark:text-tertiaire dark:group-hover:text-tertiaire" />
            <span class="ml-3">Être famille d'accueil</span>
          </router-link>
        </li>
        <li>
          <router-link to="animaux-perdus" @click="handleLinkClick"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group"
            active-class="bg-primaire text-secondaire">
            <font-awesome-icon :icon="['fas', 'cat']"
              class="w-5 h-5  text-tertiaire transition duration-75 group-hover:text-gray-100 dark:text-tertiaire dark:group-hover:text-tertiaire" />
            <span class="ml-3">Animaux perdus</span>
          </router-link>
        </li>

        <!-- New dropdown menu -->
        <li>
          <div @click="toggleDropdown('disponible')"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group cursor-pointer">
            <font-awesome-icon icon="paw"
              class="w-5 h-5 text-tertiaire transition duration-75 group-hover:secondaire" />
            <span class="ml-3">Chats disponibles</span>
            <font-awesome-icon :icon="dropdownStates.disponible ? 'chevron-up' : 'chevron-down'"
              class="ml-auto text-tertiaire" />
          </div>
          <ul v-if="dropdownStates.disponible" class="pl-6 mt-2 space-y-2">
            <li>
              <router-link to="chatons-0-5-mois" @click="handleLinkClick"
                class="flex items-center p-2 text-navigation bg-gray-100 border-2 border-navigation rounded-lg hover:bg-primaire hover:text-tertiaire ho group"
                active-class="text-[#2fa960] border-[#2fa960] bg-cyan-50">
                <span class="ml-3">Chatons (0-5 mois)</span>
              </router-link>
            </li>
             <li>
              <router-link to="chatons-6-12-mois" @click="handleLinkClick"
                class="flex items-center p-2 text-navigation bg-gray-100 border-2 border-navigation rounded-lg hover:bg-primaire hover:text-tertiaire ho group"
                active-class="text-[#2fa960] border-[#2fa960] bg-cyan-50">
                <span class="ml-3">Chatons (6-12 mois)</span>
              </router-link>
            </li>
            <li>
              <router-link to="chats-femelles" @click="handleLinkClick"
                class="flex items-center p-2 text-navigation bg-gray-100 border-2 border-navigation rounded-lg hover:bg-primaire hover:text-tertiaire ho group"
                active-class="text-[#2fa960] border-[#2fa960] bg-cyan-50">
                <span class="ml-3">Femelles (1 an et +)</span>
              </router-link>
            </li>
            <li>
              <router-link to="chats-males" @click="handleLinkClick"
                class="flex items-center p-2 text-navigation bg-gray-100 border-2 border-navigation rounded-lg hover:bg-primaire hover:text-tertiaire  group"
                active-class="text-[#2fa960] border-[#2fa960] bg-cyan-50">
                <span class="ml-3">Mâles (1 an et +)</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <div @click="toggleDropdown('adoptes')"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group cursor-pointer">
            <font-awesome-icon :icon="['fab', 'bluesky']"
              class="w-5 h-5 text-tertiaire transition duration-75 group-hover:secondaire" />
            <span class="ml-3">Nos adoptés</span>
            <font-awesome-icon :icon="dropdownStates.adoptes ? 'chevron-up' : 'chevron-down'"
              class="ml-auto text-tertiaire" />
          </div>
          <ul v-if="dropdownStates.adoptes" class="pl-6 mt-2 space-y-2">
            <li>
              <router-link to="statistiques" @click="handleLinkClick"
                class="flex items-center p-2 text-navigation bg-gray-100 border-2 border-navigation rounded-lg hover:bg-primaire hover:text-tertiaire ho group"
                active-class="text-[#2fa960] border-[#2fa960] bg-cyan-50">
                <span class="ml-3">Statistiques</span>
              </router-link>
            </li>
            <li>
              <router-link to="nos-adoptes" @click="handleLinkClick"
                class="flex items-center p-2 text-navigation bg-gray-100 border-2 border-navigation rounded-lg hover:bg-primaire hover:text-tertiaire ho group"
                active-class="text-[#2fa960] border-[#2fa960] bg-cyan-50">
                <span class="ml-3">Nos adoptés</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="levee-de-fonds" @click="handleLinkClick"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group"
            active-class="bg-primaire text-secondaire">
            <font-awesome-icon :icon="['fab', 'bluesky']"
              class="w-5 h-5 text-tertiaire transition duration-75 group-hover:secondaire dark:text-tertiaire dark:group-hover:text-tertiaire" />
            <span class="ml-3">Levée de fonds</span>
          </router-link>
        </li>
        <li>
          <router-link to="nos-partenaires" @click="handleLinkClick"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group"
            active-class="bg-primaire text-secondaire">
            <font-awesome-icon :icon="['fas', 'fa-users']"
              class="w-5 h-5 text-tertiaire transition duration-75 group-hover:secondaire dark:text-tertiaire dark:group-hover:text-tertiaire" />
            <span class="ml-3">Nos Partenaires</span>
          </router-link>
        </li>
        <li>
          <router-link to="nous-joindre" @click="handleLinkClick"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group"
            active-class="bg-primaire text-secondaire">
            <font-awesome-icon :icon="['far', 'envelope']"
              class="w-5 h-5 text-tertiaire transition duration-75 group-hover:secondaire dark:text-tertiaire dark:group-hover:text-tertiaire" />
            <span class="ml-3">Nous joindre</span>
          </router-link>
        </li>
        <li>
          <router-link to="admin" @click="handleLinkClick"
            class="flex items-center p-2 text-tertiaire bg-navigation rounded-lg hover:bg-primaire group"
            active-class="bg-primaire text-secondaire">
            <font-awesome-icon :icon="['fas', 'lock']"
              class="w-5 h-5 text-tertiaire transition duration-75 group-hover:secondaire dark:text-tertiaire dark:group-hover:text-tertiaire" />
            <span class="ml-3">Admin</span>
          </router-link>
        </li>
      </ul>

    </div>
  </aside>
</template>

<script setup>
import { isSidebarOpen, sidebarWidth, closeSidebar } from '../store/storeSideBar.js';
import { ref, onMounted } from 'vue';

const dropdownStates = ref({
  apropos: false,
  disponible: false,
});

function toggleDropdown(menu) {
  dropdownStates.value[menu] = !dropdownStates.value[menu];
}

function handleLinkClick() {
  if (window.innerWidth < 768) {
    closeSidebar();
  }
}

function isActiveRoute(path) {
  return route.path === path;
}

onMounted(() => {
  closeSidebar(); // Fermeture de la sidebar au chargement de la page
});
</script>